import fireGtagEvent from '@sls-react/services/analytics/fireGtagEvent';
import fireFacebookEvent from '@sls-react/services/analytics/fireFacebookEvent';

export default function analyticsPageView(url: string) {
  fireFacebookEvent('track', 'PageView');
  fireGtagEvent('event', 'page_view');
}
